import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let errorStatus: string = 'internal_error';
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                switch (error.status) {
                    case HttpStatusCode.Conflict:
                        errorStatus = 'conflict';
                        break;
                    default:
                        errorStatus = 'internal_error';
                }
                return throwError(() => new Error(errorStatus));
            }),
        );
    }
}
